/**
 * JourFerie (Public Holiday) Types
 */

export interface JourFerie {
  id: number;
  date: string;
  nom: string;
  type: 'FIXE' | 'MOBILE';
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface JourFerieCreate {
  date: string;
  nom: string;
  type: 'FIXE' | 'MOBILE';
  description?: string;
}

export interface JourFerieUpdate {
  date?: string;
  nom?: string;
  type?: 'FIXE' | 'MOBILE';
  description?: string;
}

export interface JourFerieListResponse {
  items: JourFerie[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

// Type options for dropdown
export const TYPE_JOUR_FERIE_OPTIONS = [
  { value: 'FIXE', label: 'Fixe (même date chaque année)' },
  { value: 'MOBILE', label: 'Mobile (calendrier islamique)' },
];

// Default Moroccan holidays template
export const MOROCCAN_HOLIDAYS_TEMPLATE: Omit<JourFerieCreate, 'date'>[] = [
  { nom: "Jour de l'An", type: 'FIXE', description: '1er Janvier' },
  { nom: "Manifeste de l'Indépendance", type: 'FIXE', description: '11 Janvier' },
  { nom: 'Fête du Travail', type: 'FIXE', description: '1er Mai' },
  { nom: 'Fête du Trône', type: 'FIXE', description: '30 Juillet' },
  { nom: 'Allégeance Oued Eddahab', type: 'FIXE', description: '14 Août' },
  { nom: 'Révolution du Roi et du Peuple', type: 'FIXE', description: '20 Août' },
  { nom: 'Fête de la Jeunesse', type: 'FIXE', description: '21 Août' },
  { nom: 'Marche Verte', type: 'FIXE', description: '6 Novembre' },
  { nom: "Fête de l'Indépendance", type: 'FIXE', description: '18 Novembre' },
  // Islamic holidays (dates change each year)
  { nom: 'Aïd Al Fitr (1er jour)', type: 'MOBILE', description: 'Fin du Ramadan' },
  { nom: 'Aïd Al Fitr (2ème jour)', type: 'MOBILE', description: 'Fin du Ramadan' },
  { nom: 'Aïd Al Adha (1er jour)', type: 'MOBILE', description: 'Fête du Sacrifice' },
  { nom: 'Aïd Al Adha (2ème jour)', type: 'MOBILE', description: 'Fête du Sacrifice' },
  { nom: '1er Moharram', type: 'MOBILE', description: 'Nouvel An Hijri' },
  { nom: 'Aïd Al Mawlid', type: 'MOBILE', description: 'Anniversaire du Prophète' },
];
